import React, { useLayoutEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
  Outlet,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { supabase } from './supabase';
import './App.css';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Home from './pages/Home';
import Conversations from './pages/Conversations';
import Voicemails from './pages/Voicemails';
import Suggestions from './pages/Suggestions';
import Tasks from './pages/Tasks';
import Settings from './pages/Settings';
import Onboarding from './pages/Onboarding';
import ResetPassword from './pages/ResetPassword';
import Admin from './pages/Admin';
import Outreach from './pages/Outreach';

const navLinks = [
  {
    to: '/home', label: 'Overview',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
  },
  {
    to: '/tasks', label: 'Tasks',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
  },
  {
    to: '/conversations', label: 'Conversations',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
  },
  {
    to: '/voicemails', label: 'Voicemails',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>
  },
  {
    to: '/settings', label: 'Settings',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
  },
  {
    to: '/suggestions', label: 'Suggestions',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
  },
  {
    to: '/onboarding', label: 'Setup',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M6 20v-2a6 6 0 0 1 12 0v2"/></svg>
  },
];

function DashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const currentPage = navLinks.find(n => n.to === location.pathname);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F4F7FF', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:wght@700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        .rf-top-nav { display: flex; }
        .rf-bottom-bar { display: none; }
        .rf-main { padding-bottom: 0; }
        @media (max-width: 768px) {
          .rf-top-nav { display: none; }
          .rf-bottom-bar {
            display: flex;
            position: fixed;
            bottom: 0; left: 0; right: 0;
            z-index: 100;
            background: rgba(255,255,255,0.97);
            backdrop-filter: blur(8px);
            border-top: 1px solid #DDE3F0;
            box-shadow: 0 -2px 12px rgba(26,86,219,0.08);
            padding: 8px 20px env(safe-area-inset-bottom, 10px);
            align-items: center;
            justify-content: space-between;
          }
          .rf-main { padding-bottom: 80px; }
        }
      `}</style>

      {/* Top nav — desktop */}
      <header style={{ position: 'sticky', top: 0, zIndex: 20, backgroundColor: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(8px)', borderBottom: '1px solid #DDE3F0', boxShadow: '0 1px 4px rgba(26,86,219,0.06)' }}>
        <div style={{ maxWidth: '1120px', margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '62px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '30px', height: '30px', background: '#1A56DB', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 2h12v10H9.5L6 14v-2H2V2z" fill="#fff"/></svg>
            </div>
            <span style={{ fontFamily: "'Fraunces', serif", fontWeight: 800, fontSize: '18px', letterSpacing: '-0.5px', color: '#0C1A2E' }}>ReplyFirst</span>
          </div>
          <nav className="rf-top-nav" style={{ gap: '4px' }}>
            {navLinks.map(({ to, label }) => {
              const active = location.pathname === to;
              return (
                <Link key={to} to={to} style={{ padding: '7px 14px', borderRadius: '999px', textDecoration: 'none', fontSize: '14px', fontWeight: 600, color: active ? '#1A56DB' : '#5A6B84', backgroundColor: active ? '#EEF3FF' : 'transparent', transition: 'all 0.15s' }}>
                  {label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="rf-main">
        <Outlet />
      </main>

      {/* Mobile bottom bar */}
      <div className="rf-bottom-bar">
        {/* Current page label */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{ color: '#1A56DB' }}>{currentPage?.icon}</div>
          <span style={{ fontFamily: "'Fraunces', serif", fontWeight: 800, fontSize: '16px', color: '#0C1A2E' }}>
            {currentPage?.label || 'ReplyFirst'}
          </span>
        </div>

        {/* Menu button */}
        <button
          onClick={() => setMenuOpen(true)}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 16px', borderRadius: '999px', border: '1px solid #DDE3F0', backgroundColor: '#F4F7FF', color: '#0C1A2E', fontSize: '14px', fontWeight: 600, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          Menu
        </button>
      </div>

      {/* Slide-up menu overlay */}
      {menuOpen && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setMenuOpen(false)}
            style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(12,26,46,0.5)', zIndex: 200, backdropFilter: 'blur(2px)' }}
          />
          {/* Drawer */}
          <div style={{
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 201,
            backgroundColor: '#fff', borderRadius: '20px 20px 0 0',
            padding: '12px 0 env(safe-area-inset-bottom, 24px)',
            boxShadow: '0 -8px 40px rgba(26,86,219,0.15)',
          }}>
            {/* Handle */}
            <div style={{ width: '40px', height: '4px', backgroundColor: '#DDE3F0', borderRadius: '999px', margin: '0 auto 20px' }} />

            {/* Logo */}
            <div style={{ padding: '0 24px 16px', borderBottom: '1px solid #EEF2FF', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '28px', height: '28px', background: '#1A56DB', borderRadius: '7px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M2 2h12v10H9.5L6 14v-2H2V2z" fill="#fff"/></svg>
              </div>
              <span style={{ fontFamily: "'Fraunces', serif", fontWeight: 800, fontSize: '16px', color: '#0C1A2E' }}>ReplyFirst</span>
            </div>

            {/* Nav links */}
            <div style={{ padding: '8px 16px' }}>
              {navLinks.map(({ to, label, icon }) => {
                const active = location.pathname === to;
                return (
                  <button
                    key={to}
                    onClick={() => { navigate(to); setMenuOpen(false); }}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '14px',
                      width: '100%', padding: '14px 16px', borderRadius: '12px',
                      border: 'none', textAlign: 'left', cursor: 'pointer',
                      backgroundColor: active ? '#EEF3FF' : 'transparent',
                      color: active ? '#1A56DB' : '#3D4F66',
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      fontSize: '16px', fontWeight: active ? 700 : 500,
                      marginBottom: '4px',
                    }}
                  >
                    <span style={{ color: active ? '#1A56DB' : '#9AABBE' }}>{icon}</span>
                    {label}
                    {active && (
                      <span style={{ marginLeft: 'auto', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#1A56DB' }} />
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function AuthRecoveryRedirect() {
  const navigate = useNavigate();
  useLayoutEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('type=invite') || hash.includes('type=recovery')) {
      navigate('/reset-password', { replace: true });
      return;
    }
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') navigate('/reset-password', { replace: true });
      if (event === 'SIGNED_IN' && window.location.hash.includes('type=invite')) navigate('/reset-password', { replace: true });
    });
    return () => subscription.unsubscribe();
  }, [navigate]);
  return null;
}

function App() {
  return (
    <Router>
      <AuthRecoveryRedirect />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<DashboardLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/voicemails" element={<Voicemails />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/suggestions" element={<Suggestions />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/onboarding" element={<Onboarding />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
        <Route path="/outreach" element={<Outreach />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;